import React from "react"
import './switch.css'

export const CPSwitch = ({ seleccionado = false, onClickChange }) => {
    return (
        <>
            <label className="switch" onChange={(e) => {
                const estado = e.target.checked
                //setActivar(estado)
                onClickChange(estado)
            }}>
                <input type="checkbox" checked={seleccionado} />
                <span class="slider round"></span>
            </label>
        </>

    );
}